var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.onClass,attrs:{"type":_vm.type},on:{"click":function($event){return _vm.$emit('onClick', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }